import * as React from 'react';
export const TRSvg = React.forwardRef(function TRSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
        transform: 'translate(0 2)',
      },
      /*#__PURE__*/ React.createElement('rect', {
        width: 16,
        height: 12,
        fill: '#E25950',
        rx: 2,
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'M8 2.536a3.5 3.5 0 1 0 0 6.929 4 4 0 1 1 0-6.929Z',
      }),
      /*#__PURE__*/ React.createElement('circle', {
        cx: 9,
        cy: 6,
        r: 1,
        fill: '#FFF',
      }),
    ),
  );
});
TRSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var TR = {
  category: 'flag',
  colorable: false,
  name: 'TR',
  svg: TRSvg,
};
